import { render, staticRenderFns } from "./AddColumnButton.vue?vue&type=template&id=01d91370&scoped=true"
import script from "./AddColumnButton.vue?vue&type=script&lang=js"
export * from "./AddColumnButton.vue?vue&type=script&lang=js"
import style0 from "./AddColumnButton.vue?vue&type=style&index=0&id=01d91370&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d91370",
  null
  
)

export default component.exports